var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3499 14.6633H14.8499M3.1499 14.6633L6.42439 14.0035C6.59822 13.9685 6.75784 13.8829 6.88319 13.7575L14.2134 6.42322C14.5649 6.07158 14.5647 5.50158 14.2129 5.15024L12.6601 3.59918C12.3085 3.24798 11.7388 3.24822 11.3875 3.59972L4.05647 10.9348C3.93136 11.0599 3.84594 11.2192 3.81088 11.3927L3.1499 14.6633Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlack);
export default __webpack_public_path__ + "static/media/edit-black.bad8cb3ee8e17c8a407359eda2551f89.svg";
export { ForwardRef as ReactComponent };